"use client"

import { format } from "date-fns"
import { getLocaleOrThrow } from "src/localization/state"
import { localizeText } from "src/localization/utils"
import { StorefrontDetailProduct, StorefrontDetailVariant } from "src/types/storefront"
import { getDateFnsLocale } from "src/utilities/dateFormatting"
import {
  calculateDailyFulfillmentDate,
  calculateShippingDate,
  calculateWeeklyFulfillmentDate,
  useMaxShippingDays,
  useMinShippingDays,
} from "src/utilities/delivery"
import { interpretAsGermanTimeIso } from "src/utilities/germanTime"
import { isVariantDigital } from "src/utilities/product"

export type ShippingDateProps = {
  product: StorefrontDetailProduct
  variant: StorefrontDetailVariant | undefined
}

const NormalShippingDate = ({ product, variant }: ShippingDateProps) => {
  const shippingDaysMin = useMinShippingDays()
  const shippingDaysMax = useMaxShippingDays()

  if (isVariantDigital(variant) || !shippingDaysMin || !shippingDaysMax) {
    return null
  }

  const T = localizeText(text)
  const earliestFulfillmentDate = product.fulfillmentFrom ? new Date(product.fulfillmentFrom) : new Date()
  const fulfillmentDate =
    product.fulfillmentSchedule === "daily"
      ? calculateDailyFulfillmentDate(earliestFulfillmentDate)
      : calculateWeeklyFulfillmentDate(earliestFulfillmentDate)

  const shippedByMin = calculateShippingDate(fulfillmentDate, shippingDaysMin)
  const shippedByMax = calculateShippingDate(fulfillmentDate, shippingDaysMax)

  const appLocale = getLocaleOrThrow()
  const dateFnsLocale = getDateFnsLocale(appLocale)
  const shippedByMinFormatted =
    shippedByMin.getFullYear() === shippedByMax.getFullYear() && shippedByMin.getMonth() === shippedByMax.getMonth()
      ? format(shippedByMin, "d.", { locale: dateFnsLocale })
      : shippedByMin.getFullYear() === shippedByMax.getFullYear()
        ? format(shippedByMin, "d. MMM", { locale: dateFnsLocale })
        : format(shippedByMin, "d. MMM yyyy", { locale: dateFnsLocale })

  const shippedByMaxFormatted = format(shippedByMax, "d. MMM yyyy", { locale: dateFnsLocale })

  const shippingDateShort = `${shippedByMinFormatted} - ${shippedByMaxFormatted}`
  const shippingDateLong = T.format_shippingDateLong(shippingDateShort)

  return <div>{shippingDateLong}</div>
}

const de = {
  format_shippingDateLong: (dateRange: string) => `Bei dir am ${dateRange}`,
}

const en: typeof de = {
  format_shippingDateLong: (dateRange: string) => `Arrives by ${dateRange}`,
}

const text = { en, de }

const ChristmasBreakShippingDate = () => {
  return <div>Ab dem 7. Januar wieder lieferbar</div>
}

const startOfBreak = interpretAsGermanTimeIso("2024-12-20")
const endOfBreak = interpretAsGermanTimeIso("2025-01-04")

export const ShippingDate = ({ product, variant }: ShippingDateProps) => {
  return (
    <>
      {/* <TimeRestrictedContent end={startOfBreak}>
        <NormalShippingDate product={product} variant={variant} />
      </TimeRestrictedContent>
      <TimeRestrictedContent start={startOfBreak} end={endOfBreak}>
        <ChristmasBreakShippingDate />
      </TimeRestrictedContent>
      <TimeRestrictedContent start={endOfBreak}> */}
      <NormalShippingDate product={product} variant={variant} />
      {/* </TimeRestrictedContent> */}
    </>
  )
}
